// Styles for PartnerCard go here.
import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledPartnerCard = styled.div`
  width: 100%;
  height: 100%;
  .partnercard {
    width: auto;
    height: 100%;
    border-radius: ${toRem(14)};
    box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);
    overflow: hidden;

    &_chevron {
      position: relative;
      max-width: fit-content;
      &[class*='icon-arrow-']:before {
        position: absolute;
        right: ${toRem(32)};
        bottom: ${toRem(32)};
        z-index: 1;
        font-size: ${toRem(24)};
      }
    }

    &_container {
      position: relative;
      overflow: hidden;
      max-width: 100%;
      width: fit-content;
      height: 100%;

      .image {
        max-width: 100%;
      }
    }

    &__body {
      width: 100%;
    }

    &_overlay {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
    }

    &_badge {
      border-radius: ${toRem(4)};
      background: ${baseVariables.color['accent10']};
    }

    &_image {
      position: relative;
    }

    &_brandlogo {
      box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);
      position: absolute;
      left: ${toRem(32)};
      bottom: ${toRem(-20)};
      height: ${toRem(64)};
      width: ${toRem(64)};
      border-radius: ${toRem(134)};
      background: ${baseVariables.color['base20']};
      box-shadow: ${baseVariables.shadows['shadow02']};
      border: ${toRem(8)} solid rgba(0, 0, 0, 0);
    }

    &_heading {
      color: ${baseVariables.color['neutral40']};
    }

    &_description {
      p {
        margin-bottom: 0;
      }
    }
  }
`;
